var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 110,
    viewBox: "0 0 260 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2753 16.0557C32.7473 16.0557 30.6951 18.0792 30.6951 20.5718L30.6951 66.5689C30.6951 69.0616 32.7473 71.085 35.2753 71.085C37.8033 71.085 39.8555 69.0616 39.8555 66.5689L39.8555 20.5718C39.8555 18.0792 37.8033 16.0557 35.2753 16.0557Z",
    fill: "url(#paint0_linear_5157_907)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80078 110C30.4116 110 48.9852 100.968 63.5139 83.871C74.1167 71.4076 78.8902 58.8856 79.0836 58.3578C79.1133 58.2845 83.0838 48.0499 91.6642 38.1232C102.445 25.6598 115.338 19.3402 130.001 19.3402C135.414 19.3402 139.801 15.0147 139.801 9.67742C139.801 4.32551 135.414 -1.91756e-07 130.001 -4.28364e-07C109.39 -1.32929e-06 90.8166 9.03226 76.2878 26.129C65.685 38.607 60.9115 51.129 60.7182 51.6569C60.6885 51.7302 56.718 61.9648 48.1375 71.8915C37.3563 84.3548 24.4633 90.6745 9.80078 90.6745C4.38783 90.6745 0.000957151 95 0.000956918 100.337C0.000956685 105.674 4.38783 110 9.80078 110Z",
    fill: "url(#paint1_linear_5157_907)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.001 110C135.414 110 139.801 105.674 139.801 100.337C139.801 95 135.414 90.6745 130.001 90.6745C115.338 90.6745 102.445 84.3548 91.6642 71.8915C83.0838 61.9648 79.1133 51.7302 79.0836 51.6276C78.8902 51.129 74.1316 38.607 63.5139 26.129C48.9852 9.03225 30.4116 -4.78155e-06 9.80078 -5.68248e-06C4.38783 -5.91909e-06 0.000961115 4.32551 0.000960881 9.66275C0.000960648 15 4.38783 19.3255 9.80078 19.3255C24.4633 19.3255 37.3563 25.6452 48.1375 38.1085C56.718 48.0352 60.6885 58.2698 60.7182 58.3724C60.9115 58.871 65.6701 71.393 76.2878 83.871C90.8166 100.968 109.39 110 130.001 110Z",
    fill: "url(#paint2_linear_5157_907)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130 110C150.611 110 169.184 100.968 183.713 83.871C194.331 71.4076 199.089 58.8856 199.283 58.3578C199.313 58.2845 203.283 48.0499 211.863 38.1232C222.645 25.6598 235.538 19.3402 250.2 19.3402C255.613 19.3255 260 15 260 9.66276C260 4.32551 255.613 -1.91756e-07 250.2 -4.28364e-07C229.589 -1.32929e-06 211.016 9.03226 196.487 26.129C185.884 38.607 181.111 51.129 180.917 51.6569C180.888 51.7302 176.917 61.9648 168.337 71.8915C157.555 84.3548 144.663 90.6745 130 90.6745C124.587 90.6745 120.2 95 120.2 100.337C120.2 105.674 124.587 110 130 110Z",
    fill: "url(#paint3_linear_5157_907)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M155.474 16.0557C152.946 16.0557 150.894 18.0792 150.894 20.5719L150.894 66.5689C150.894 69.0616 152.946 71.0851 155.474 71.0851C158.003 71.0851 160.055 69.0616 160.055 66.5689L160.055 20.5719C160.055 18.0792 158.003 16.0557 155.474 16.0557Z",
    fill: "url(#paint4_linear_5157_907)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M130.002 82.5073C132.53 82.5073 134.582 80.4839 134.582 77.9912L134.582 31.9941C134.582 29.5015 132.53 27.478 130.002 27.478C127.474 27.478 125.422 29.5015 125.422 31.9941L125.422 77.9912C125.422 80.4839 127.474 82.5073 130.002 82.5073Z",
    fill: "url(#paint5_linear_5157_907)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M104.525 93.9443C107.053 93.9443 109.105 91.9208 109.105 89.4282L109.105 43.4311C109.105 40.9384 107.053 38.9149 104.525 38.9149C101.997 38.9149 99.9451 40.9384 99.9451 43.4311L99.9451 89.4281C99.9451 91.9208 101.997 93.9443 104.525 93.9443Z",
    fill: "url(#paint6_linear_5157_907)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M250.2 110C255.613 110 260 105.674 260 100.337C260 95 255.613 90.6745 250.2 90.6745C235.538 90.6745 222.645 84.3548 211.863 71.8915C203.283 61.9648 199.313 51.7302 199.283 51.6276C199.089 51.129 194.331 38.607 183.713 26.129C169.184 9.03225 150.611 -4.78155e-06 130 -5.68248e-06C124.587 -5.91909e-06 120.2 4.32551 120.2 9.66275C120.2 15 124.587 19.3255 130 19.3255C144.663 19.3255 157.555 25.6452 168.337 38.1085C176.917 48.0352 180.888 58.2698 180.917 58.3724C181.111 58.871 185.869 71.393 196.487 83.871C211.016 100.968 229.589 110 250.2 110Z",
    fill: "url(#paint7_linear_5157_907)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M225.381 93.9443C227.909 93.9443 229.961 91.9208 229.961 89.4282L229.961 43.4311C229.961 40.9384 227.909 38.915 225.381 38.915C222.853 38.915 220.801 40.9384 220.801 43.4311L220.801 89.4282C220.801 91.9208 222.853 93.9443 225.381 93.9443Z",
    fill: "url(#paint8_linear_5157_907)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5157_907",
    x1: 35.276,
    y1: 7.44199,
    x2: 35.276,
    y2: 104.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45A9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5EDFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5157_907",
    x1: 69.8986,
    y1: 1.43006,
    x2: 69.8986,
    y2: 107.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C27DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45A9FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5157_907",
    x1: 69.8986,
    y1: -0.287525,
    x2: 69.8986,
    y2: 104.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D843B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A38D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5157_907",
    x1: 190.1,
    y1: -0.287598,
    x2: 190.1,
    y2: 104.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D843B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A38D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5157_907",
    x1: 155.477,
    y1: 7.442,
    x2: 155.477,
    y2: 104.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45A9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5EDFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5157_907",
    x1: 130.001,
    y1: 7.44198,
    x2: 130.001,
    y2: 104.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45A9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5EDFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5157_907",
    x1: 104.52,
    y1: 7.44206,
    x2: 104.52,
    y2: 104.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45A9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5EDFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5157_907",
    x1: 190.1,
    y1: 1.43006,
    x2: 190.1,
    y2: 107.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C27DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45A9FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5157_907",
    x1: 225.377,
    y1: 7.442,
    x2: 225.377,
    y2: 104.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45A9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5EDFE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDna);
export default __webpack_public_path__ + "static/media/DNA.9d295c3645e8374eb04e947235faafd3.svg";
export { ForwardRef as ReactComponent };